import { createClient } from '@supabase/supabase-js'

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  realtime: {
    params: {
      eventsPerSecond: 10,  // Rate limiting to prevent flooding
    },
    heartbeatIntervalMs: 30000,  // Send heartbeat every 30 seconds to detect stale connections
    reconnectAfterMs: (attempts) => {
      // Exponential backoff: 1s, 2s, 4s, 8s... max 30s
      return Math.min(1000 * Math.pow(2, attempts), 30000)
    },
  },
})